<template>
    <vx-expandable-card>
        <template v-slot:header>Effective At</template>
        <template v-slot:content>
            <vx-date-time-picker
                v-model="effectiveAtDate"
                :timezone="clientTimezone"
                :minDate="minEffectiveDate"
                :disabled="!props.canEdit"
                :error="displayFirstError(validation.effective_at.$errors)"
                isRequired
                data-test="effective-at-picker"
            />
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxDateTimePicker, VxExpandableCard } from '@voxie/frontend-components';
import { computed } from 'vue';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { displayFirstError, isAfterDate } from '~/utils/validation';
import dayjs from '~/utils/dayjs';
import { getClientTz } from '~/utils/date';
import type { TermFormData } from '~/services/adminTermsClient.types';

const props = defineProps<{
    canEdit: boolean;
}>();

const data = defineModel<TermFormData>({ required: true });

const clientTimezone = getClientTz();
const minEffectiveDate = computed(() => dayjs().tz(clientTimezone).toDate());

const effectiveAtDate = computed<Date | undefined>({
    get() {
        if (!data.value.effective_at) {
            return undefined;
        }
        const parsed = dayjs.utc(data.value.effective_at);
        return parsed.isValid() ? parsed.toDate() : undefined;
    },
    set(newValue) {
        data.value.effective_at = newValue ? dayjs(newValue).toISOString() : '';
    },
});

const validation = useVuelidate(
    {
        effective_at: { required, isAfter: isAfterDate({ required: true }) },
    },
    data
);
</script>
